import { NgModule } from '@angular/core'
import { FloVideoAutoplayDirective } from './ng-video-autoplay.directive'

@NgModule({
  declarations: [
    FloVideoAutoplayDirective
  ],
  exports: [
    FloVideoAutoplayDirective
  ]
})
export class FloVideoAutoplayModule { }
